import { h, Component } from 'preact';
import styles from './text_area_field_style';
import classNames from 'classnames';


export default class TextAreaField extends Component {
  updateValue = (e) => {
    this.props.updateValue(e.target.value);
  } 
  render({field, isValid},{}) {
		var classes = classNames({
      'form-control': true,
      'is-invalid': !isValid
    });
		return (
      <textarea id={field.mapping} name={field.mapping} rows="5" placeholder={field.label} class={classes} onBlur={this.updateValue} />
		);
	}
}



// WEBPACK FOOTER //
// ./field_types/text_area_field.js